import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface AcsTokenResponse {
  token: string;
  acsUserId: string;
}

@Injectable({
  providedIn: 'root'
})
export class AcsService {
  readonly _ENDPOINT = '/acs/';

  constructor(private http: HttpClient) {}

  getToken(siteContactId: string): Observable<AcsTokenResponse> {
    return this.http.get<AcsTokenResponse>(environment.apiUrl + this._ENDPOINT + 'token/' + siteContactId);
  }
}
